export class CnctProTokenManager {
  private tokenEndpoint: string;
  private clientId: string;
  private refreshToken: string;

  private lastAccessToken = '';
  private lastTokenExpiration = 0;

  constructor() {
    this.tokenEndpoint = process.env.VUE_APP_CNCTPRO_TOKEN_ENDPOINT;
    this.clientId = process.env.VUE_APP_CNCTPRO_CLIENT_ID;
    this.refreshToken = process.env.VUE_APP_CNCTPRO_REFRESH_TOKEN;
  }

  async getToken(): Promise<string> {
    // If the token is still valid, return it
    if (this.lastTokenExpiration > Date.now()) return this.lastAccessToken;

    // Otherwise, get a new token from openid connect server
    const body = new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: this.clientId,
      refresh_token: this.refreshToken,
      scope: 'openid',
    });

    const response = await fetch(this.tokenEndpoint, {
      method: 'POST',
      body,
    });

    if (!response.ok) {
      throw new Error(`Failed to get token: ${response.status}`);
    }

    const data = await response.json();

    this.lastAccessToken = data.access_token;
    if (data.expires_in) {
      // Margin of 5 seconds
      this.lastTokenExpiration = Date.now() + (data.expires_in - 5) * 1000;
    }
    return data.access_token;
  }
}
